export const LOAD_LMS_COURSES_REQUEST = 'LOAD_LMS_COURSES_REQUEST';
export const LOAD_LMS_COURSES_SUCCESS = 'LOAD_LMS_COURSES_SUCCESS';
export const LOAD_LMS_COURSES_FAILURE = 'LOAD_LMS_COURSES_FAILURE';

export const LOAD_LMS_COURSE_REQUEST = 'LOAD_LMS_COURSE_REQUEST';
export const LOAD_LMS_COURSE_SUCCESS = 'LOAD_LMS_COURSE_SUCCESS';
export const LOAD_LMS_COURSE_FAILURE = 'LOAD_LMS_COURSE_FAILURE';

export const LOAD_LMS_COURSE_MATERIALS_REQUEST = 'LOAD_LMS_COURSE_MATERIALS_REQUEST';
export const LOAD_LMS_COURSE_MATERIALS_SUCCESS = 'LOAD_LMS_COURSE_MATERIALS_SUCCESS';
export const LOAD_LMS_COURSE_MATERIALS_FAILURE = 'LOAD_LMS_COURSE_MATERIALS_FAILURE';

export const LOAD_LMS_COURSE_MATERIAL_REQUEST = 'LOAD_LMS_COURSE_MATERIAL_REQUEST';
export const LOAD_LMS_COURSE_MATERIAL_SUCCESS = 'LOAD_LMS_COURSE_MATERIAL_SUCCESS';
export const LOAD_LMS_COURSE_MATERIAL_FAILURE = 'LOAD_LMS_COURSE_MATERIAL_FAILURE';

export const UPDATE_LMS_COURSE_MATERIAL_REQUEST = 'UPDATE_LMS_COURSE_MATERIAL_REQUEST';
